// ── V122: 레시피 식재료 중국어 ────────────────────────────────────────────────
// 레시피 식재료 목록의 중국어는 단가표(name_zh)에서 가져온다.
// 반제품 레시피(삶은 닭·염지제 등)는 식재료로 쓰려고 단가표에도 한 줄로 들어가는데,
// 그 줄을 만들 때는 아직 번역 전이라 중국어가 비어 있었다 → 식재료 목록·발주서에 한국어만 보였다.
// 여기 함수들은 화면·저장 없이 '무엇을 바꿀지'만 계산한다 (App.js가 저장).
import { buildZhMap, zhOf } from '../i18n/BiName';
import { normalizeIngredientName } from './ingredientMatch';

const s = v => String(v == null ? '' : v).trim();
const HANGUL = /[가-힣]/;

/** 반제품 레시피의 중국어 이름을 같은 이름의 단가표 줄(중국어 빈 칸)에 채운다 */
export function semiZhPatch(prices, recipes) {
  const zhByName = new Map();
  for (const r of recipes || []) {
    const zh = s(r && r.name_zh);
    if (r && r.type !== 'menu' && zh) zhByName.set(normalizeIngredientName(r.name), zh);
  }
  let changed = 0;
  const next = (prices || []).map(p => {
    if (!p || s(p.name_zh)) return p;
    const zh = zhByName.get(normalizeIngredientName(p.name));
    if (!zh) return p;
    changed++;
    return { ...p, name_zh: zh };
  });
  return { next, changed };
}

/** 레시피 식재료 중 중국어가 없는 이름 (단가표 name_zh도, 같은 이름 레시피의 중국어도 없는 것) */
export function missingIngredientZh(prices, recipes) {
  const m = buildZhMap(prices || [], recipes || []);
  const out = new Set();
  for (const r of recipes || []) {
    for (const ing of (r && r.ingredients) || []) {
      const n = s(ing && ing.name);
      if (n && HANGUL.test(n) && !zhOf(m, n)) out.add(n);
    }
  }
  return [...out];
}

/** 번역된 단가표 줄(같은 이름)의 중국어를 '지금' 단가표의 빈 칸에만 채운다 */
export function mergePriceZh(prices, translatedRows, zhFields) {
  const byName = new Map((translatedRows || []).filter(Boolean).map(r => [normalizeIngredientName(r.name), r]));
  let changed = 0;
  const next = (prices || []).map(p => {
    const tr = p && byName.get(normalizeIngredientName(p.name));
    if (!tr) return p;
    let out = p;
    for (const zf of zhFields) {
      if (!s(p[zf]) && s(tr[zf])) {
        if (out === p) out = { ...p };
        out[zf] = s(tr[zf]);
        changed++;
      }
    }
    return out;
  });
  return { next, changed };
}

/** 아직 중국어가 없는 레시피 이름·메모·카테고리 — 화면에 '못 채운 것'으로 보여준다 */
export function listMissingRecipeZh(categories) {
  const failed = [];
  for (const c of categories || []) {
    if (s(c && c.name) && !c.name_zh) failed.push({ name: s(c.name), what: 'cat' });
    for (const i of (c && c.items) || []) {
      if (s(i.name) && !i.name_zh) failed.push({ name: s(i.name), what: 'name' });
      if (s(i.note) && !i.note_zh) failed.push({ name: s(i.name), what: 'note' });
    }
  }
  return failed;
}
